<template>
  <div class="col-sm-12 routa-light asphalt">
    <h1 class="title orange">{{ $t('menu.references') }}</h1>
    <!--References-->
    <b-row class="reference-container" align-h="center">
      <div class="col-sm-4">
        <div class="reference">
          <img class="img-fluid w-100" src=""/>
          <span class="sub-title orange">{{ $t('references.title1')}}</span>
          <span class="reference-text">{{ $t('references.description1')}}</span>
          <span class="case-text">{{ $t('references.customer1')}}</span>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="reference">
          <img class="img-fluid w-100" src=""/>
          <span class="sub-title orange">{{ $t('references.title2')}}</span>
          <span class="reference-text">{{ $t('references.description2')}}</span>
          <span class="case-text">{{ $t('references.customer2')}}</span>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="reference">
          <img class="img-fluid w-100" src=""/>
          <span class="sub-title orange">{{ $t('references.title3')}}</span>
          <span class="reference-text">{{ $t('references.description3')}}</span>
          <span class="case-text">{{ $t('references.customer3')}}</span>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'References',
}
</script>

